module.exports = __webpack_public_path__ + "img/injectionsteps_step1.8fa76a99.png";